import animationData from "assets/lotties/notfound.json"
import Lottie, { Options } from "react-lottie"
import { t } from "ttag"
import { Component } from "utilities/types"

import * as Styles from "./NotFoundPage.styles"

const lottieOptions: Options = {
  animationData: animationData,
  autoplay: true,
  loop: true,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
}

export const NotFoundPage: Component = () => {
  return (
    <Styles.ErrorPage>
      <Styles.Title
        size="extraLarge"
        color="black"
        subtitle={"Malheureusement, la page demandée n'existe pas. Vérifiez que l'url est correcte."}
      >
        {t`Page non disponible.`}
      </Styles.Title>
      <Styles.AnimationContainer>
        <Lottie options={lottieOptions}/>
      </Styles.AnimationContainer>
    </Styles.ErrorPage>
  )
}
